import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilderModule } from '@rd/form-builder/form-builder.module';
import { RecipientDetailFormComponent } from './recipient-detail-form.component';
import { RecipientDetailFormService } from './recipient-detail-form.service';

@NgModule({
  declarations: [RecipientDetailFormComponent],
  imports: [CommonModule, FormBuilderModule, ReactiveFormsModule, FormsModule],
  providers: [RecipientDetailFormService],
  exports: [RecipientDetailFormComponent],
})
export class RecipientDetailFormModule {}
